// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  communicationPreferences: {
    name: 'communicationPreferences',
    componentName: 'CommunicationPreferencesHOC',
    chunk: () => import(
      /* webpackChunkName: "communicationPreferences" */
      './pages/CommunicationPreferencesHOC'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/CommunicationPreferencesHOC')).CommunicationPreferencesHOC
        : currentRouteName === 'communicationPreferencesHOC'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.CommunicationPreferencesHOC })));
    },
    path: '/:context?/myaccount/preferences',
    channel: null
  },
});
